import { render, staticRenderFns } from "./HeaderCmsMenu.vue?vue&type=template&id=455c7d4b&scoped=true&"
import script from "./HeaderCmsMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderCmsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderCmsMenu.vue?vue&type=style&index=0&id=455c7d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c7d4b",
  null
  
)

export default component.exports